<template>
	<main-layout>
		<!-- <div class="layout-body"> -->

		<paginate v-bind:items="history" v-bind:className="'table'" v-bind:items-per-page="itemsPerPage">
			<template slot-scope="props" slot="other">
				<select v-model="profileSelected" v-on:change="refresh">
					<option disabled value="">Please select one</option>
					<template v-for="(profile,membershipId) of profiles">
						<option v-bind:value="profile.profile.membershipType">{{getMembershipTypeName(profile.profile.membershipType)}}</option>
					</template>
				</select>
				<input type="button" v-on:click="refresh" value="Refresh" />
			</template>
			<template slot-scope="props" slot="item">
				<div :key="props.itemKey" class="table-row">
					<div class="table-cell timestamp" v-bind:title="moment(props.item.timestamp).format('ddd[,] ll LTS')">
						<a href="http://destinytracker.com/d2/pgcr/808481451"></a>{{ getActivityName(props.item) }}
						<br>{{ getActivityModeName(props.item) }}
						<br>{{ moment(props.item.timestamp).fromNow() }}</div>
					<div v-for="inventoryType in inventoryTypes" v-bind:class="['table-cell',inventoryType]" v-bind:title="inventoryType" v-if="props.item[inventoryType]">
						<template v-for="item in props.item[inventoryType]" v-if="">
							<!-- <popper trigger="hover" :options="{placement: 'bottom'}"> -->
							<v-popover trigger="hover">
								<item-node :data="item" class="tooltip-target"></item-node>
								<template slot="popover" class="popper" v-if="typeof item.itemHash !== 'undefined' && getItemDef(item)">
									<tooltip :data="item" :item-def="DestinyInventoryItemDefinition[item.itemHash]" :type="'item'"></tooltip>
								</template>
								<template slot="popover" class="popper" v-else-if="typeof item.progressionHash !== 'undefined' && getProgressionDef(item) && getProgressionDef(item).factionHash">
									<tooltip :data="item" :item-def="getFactionDef(getProgressionDef(item))" :type="'faction'"></tooltip>
								</template>
								<template slot="popover" class="popper" v-else-if="typeof item.progressionHash !== 'undefined' && getProgressionDef(item)">
									<tooltip :data="item" :item-def="getProgressionDef(item)" :type="'progression'"></tooltip>
								</template>
								<template slot="popover" class="popper" v-else-if="typeof item.factionHash !== 'undefined' && getFactionDef(item)">
									<tooltip :data="item" :item-def="getFactionDef(item)" :type="'faction'"></tooltip>
								</template>
								<template slot="popover" class="popper" v-else></template>
								<!-- </popper> -->
							</v-popover>
						</template>
					</div>
				</div>
			</template>
		</paginate>
		<!-- <paginate-links for="history" :limit="2" :show-step-links="true"></paginate-links> -->
		<!-- <virtual-scroller class="scroller" :items="history" item-height="70" :pool-size="3" :key-field="'timestamp'">
			<template slot-scope="props" class="table">
				<div :key="props.itemKey" class="table-row">
					<div class="table-cell timestamp" v-bind:title="moment(props.item.timestamp).format('ddd[,] ll LTS')">{{ moment(props.item.timestamp).fromNow() }}</div>
					<div v-for="inventoryType in inventoryTypes" v-bind:class="['table-cell',inventoryType]" v-if="props.item[inventoryType]">
						<template v-for="item in props.item[inventoryType]">
							<popper trigger="hover" :options="{placement: 'bottom'}">
								<div class="popper" v-if="typeof item.itemHash !== 'undefined' && typeof DestinyInventoryItemDefinition[item.itemHash] !== 'undefined'">
									<tooltip :data="item" :item-def="DestinyInventoryItemDefinition[item.itemHash]"></tooltip>
								</div>
								<div class="popper" v-else></div>

								<item-node :data="item" slot="reference"></item-node>
							</popper>
						</template>
					</div>
				</div>
			</template>
		</virtual-scroller> -->
		<!-- <div v-for="itemDiff in history" class="table-row">
				<div class="table-cell">{{ moment(itemDiff.timestamp).format() }}</div>
				<div v-for="inventoryType in inventoryTypes" class="table-cell">
					<div v-for="item in itemDiff[inventoryType]" class="item-container">
						<div class="item" v-if="typeof item.itemHash !== 'undefined'" v-bind:style="'background-image:url(https://www.bungie.net' + DestinyInventoryItemDefinition[item.itemHash].icon + '),url(../assets/missing_icon.png)'"></div>
						<div class="faction" v-else-if="typeof item.progressionHash !== 'undefined' && DestinyProgressionDefinition[item.progressionHash].factionHash"
						    v-bind:style="'background-image:url(https://www.bungie.net' + DestinyFactionDefinition[DestinyProgressionDefinition[item.progressionHash].factionHash].factionIcon + ')'"></div>
						<div class="faction" v-else-if="typeof item.progressionHash !== 'undefined'" v-bind:style="'background-image:url(https://www.bungie.net' + DestinyProgressionDefinition[item.progressionHash].icon + ')'"></div>
						<div class="faction" v-else-if="typeof item.factionHash !== 'undefined'" v-bind:style="'background-image:url(https://www.bungie.net' + DestinyFactionDefinition[item.factionHash].factionIcon + ')'"></div>
						<div class="primary-stat" v-if="typeof item.primaryStat !== 'undefined'">{{ item.primaryStat.value }}</div>
						<div class="primary-stat" v-else-if="typeof item.objectives !== 'undefined'">{{ itemObjectivePercentage(item.objectives) }}%</div>
						<div class="primary-stat" v-else-if="typeof item.currentProgress !== 'undefined'">{{ item.currentProgress }}</div>
						<div class="primary-stat" v-else>{{ item.stackSize }}</div>
					</div>
				</div>
			</div> -->
		<!-- </div> -->
	</main-layout>
</template>

<style>
	.v-popover {
		display: inline;
	}

	select,
	input {
		display: inline-block;
		/* padding-left: 0; */
		margin: 20px 5px;
		border-radius: 4px;
		box-sizing: border-box;
		vertical-align: top;
		/* position: relative; */
		/* float: left; */
		padding: 6px 12px;
		/* margin-left: -1px; */
		line-height: 1.42857143;
		color: #337ab7;
		text-decoration: none;
		background-color: #fff;
		border: 1px solid #ddd;
	}

	.table-cell>span {
		display: inline-block
	}

	.layout-body {
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-flex: 1;
		-webkit-flex: 1 0 auto;
		-ms-flex: 1 0 auto;
		flex: 1 0 auto;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		flex-direction: column;
		padding: 1.5em;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		-ms-flex-direction: row;
		flex-direction: row;
		height: calc(100% - 50px);
		overflow-y: scroll;
		box-sizing: border-box;
	}

	.scroller {
		/* height: 100%; */
		height: calc(100% - 50px);
		width: 100%;
		overflow-y: scroll;
		box-sizing: border-box;
		padding: 2em;
	}

	.items {
		display: table;
		font-family: Arial, Helvetica, sans-serif;
	}

	.table-row {
		display: table-row;
	}

	.table-cell {
		display: inline-block;
		vertical-align: middle;
	}

	.table-cell.progression,
	.table-cell.added,
	.table-cell.removed,
	.table-cell.modified {
		padding: 0.5em 1em;
	}

	.table-cell.progression {
		background: rgba(200, 200, 200, 0.5)
	}

	.table-cell.added {
		background: rgba(0, 255, 0, 0.25)
	}

	.table-cell.removed {
		background: rgba(255, 0, 0, 0.25)
	}

	.table-cell.modified {
		background: rgba(0, 0, 255, 0.25)
	}

	.table-cell.progression::before,
	.table-cell.added::before,
	.table-cell.removed::before,
	.table-cell.modified::before {
		font-weight: bold;
		font-family: Arial, Helvetica, sans-serif;
		font-size: 46px;
		vertical-align: top;
	}

	.table-cell.progression::before {
		content: "%";
	}

	.table-cell.added::before {
		content: "+";
	}

	.table-cell.removed::before {
		content: "−";
	}

	.table-cell.modified::before {
		content: "#";
	}

	.table {
		display: table;
		margin-left: 0.5em;
	}


	.tooltip {
		display: block!important;
		z-index: 10000
	}

	.tooltip .tooltip-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: #000;
		z-index: 1
	}

	.tooltip[x-placement^=top] {
		margin-bottom: 5px
	}

	.tooltip[x-placement^=top] .tooltip-arrow {
		border-width: 5px 5px 0;
		border-left-color: transparent!important;
		border-right-color: transparent!important;
		border-bottom-color: transparent!important;
		bottom: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0
	}

	.tooltip[x-placement^=bottom] {
		margin-top: 5px
	}

	.tooltip[x-placement^=bottom] .tooltip-arrow {
		border-width: 0 5px 5px;
		border-left-color: transparent!important;
		border-right-color: transparent!important;
		border-top-color: transparent!important;
		top: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0
	}

	.tooltip[x-placement^=right] {
		margin-left: 5px
	}

	.tooltip[x-placement^=right] .tooltip-arrow {
		border-width: 5px 5px 5px 0;
		border-left-color: transparent!important;
		border-top-color: transparent!important;
		border-bottom-color: transparent!important;
		left: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0
	}

	.tooltip[x-placement^=left] {
		margin-right: 5px
	}

	.tooltip[x-placement^=left] .tooltip-arrow {
		border-width: 5px 0 5px 5px;
		border-top-color: transparent!important;
		border-right-color: transparent!important;
		border-bottom-color: transparent!important;
		right: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0
	}

	.tooltip[aria-hidden=true] {
		visibility: hidden;
		opacity: 0;
		transition: opacity .15s, visibility .15s
	}

	.tooltip[aria-hidden=false] {
		visibility: visible;
		opacity: 1;
		transition: opacity .15s
	}

	.tooltip.popover .popover-arrow {
		border-color: #f9f9f9
	}
</style>

<script>
	import Vue from 'vue'
	import MainLayout from '../layouts/Main.vue'
	import moment from '../moment.min.js'
	import Item from '../components/Item.vue'
	import Tooltip from '../components/Tooltip.vue'
	import drive from '../shared/drive'
	import bungie from '../shared/bungie'
	import Paginate from '../components/Paginate.vue'
	import VTooltip from 'v-tooltip'
	Vue.use(VTooltip)
	// import Popper from 'vue-popperjs';
	// import 'vue-popperjs/dist/css/vue-popper.css';
	let inventoryTypes = ["progression", "added", "removed", "modified"];
	for (let hash in DestinyFactionDefinition) {
		if (typeof DestinyFactionDefinition[hash].progressionHash === "number") {
			if (DestinyProgressionDefinition[DestinyFactionDefinition[hash].progressionHash]) {
				DestinyProgressionDefinition[DestinyFactionDefinition[hash].progressionHash].factionHash = hash;
				// console.log(`factionHash: ${hash}, progressionHash: ${DestinyFactionDefinition[hash].progressionHash}`)
			}
		}
	}

	window.bungie = bungie;
	export default {
		components: {
			'main-layout': MainLayout,
			'paginate': Paginate,
			'item-node': Item,
			'tooltip': Tooltip,
			// 'popper': Popper
		},
		data: function () {
			return {
				DestinyInventoryItemDefinition: DestinyInventoryItemDefinition,
				DestinyFactionDefinition: DestinyFactionDefinition,
				DestinyProgressionDefinition: DestinyProgressionDefinition,
				DestinyActivityModeDefinition: DestinyActivityModeDefinition,
				DestinyActivityDefinition: DestinyActivityDefinition,
				inventoryTypes: inventoryTypes,
				history: [],
				membershipTypes: [],
				profiles: {},
				profileSelected: "",
				itemsPerPage: Math.floor((document.documentElement.clientHeight - 117) / 66)
			};
		},
		ready() {
			window.addEventListener('resize', this.handleResize)
		},
		created() {
			let self = this;
			drive.postAuth(function () {
				// bungie.auth().then(self.getHistory);
				self.getHistory()
			})
		},
		methods: {
			querySelector: function (query) {
				return document.querySelector(query)
			},
			getMembershipTypeName(membershipType) {
				if (membershipType === 1) {
					return "XBOX";
				}
				if (membershipType === 2) {
					return "PLAYSTATION";
				}
				if (membershipType === 4) {
					return "BLIZZARD";
				}
			},
			handleResize(event) {
				this.itemsPerPage = Math.floor((document.documentElement.clientHeight - 46) / 66);
			},
			getActivityName(item) {
				let activity = DestinyActivityDefinition[item.activityHash];
				if (activity) {
					return activity.displayProperties.name;
				}
				return "";
			},
			getActivityModeName(item) {
				let activityMode = DestinyActivityModeDefinition[item.activityModeHash];
				if (activityMode) {
					return `(${activityMode.friendlyName})`;
				}
				return "";
			},
			getItemDef(item) {
				return DestinyInventoryItemDefinition[item.itemHash];
			},
			getProgressionDef(item) {
				return DestinyProgressionDefinition[item.progressionHash];
			},
			getFactionDef(item) {
				return DestinyFactionDefinition[item.factionHash];
			},
			moment: function (data) {
				return moment(data);
			},
			refresh: function () {
				let self = this;
				drive.getFile(drive.files[`history${self.profileSelected}`]).then(function (fileDetails) {
					if (typeof fileDetails.data !== "undefined") {
						self.history = fileDetails.data.history;
					}
				})
			},
			getHistory: function () {
				let self = this;
				drive.getFile(drive.files.profiles).then(function (fileDetails) {
					if (fileDetails && fileDetails.data) {
						for (let membershipId of Object.keys(fileDetails.data)) {
							self.profiles[membershipId] = fileDetails.data[membershipId];
							if (self.membershipTypes.indexOf(self.profiles[membershipId].profile.membershipType) === -1) {
								self.membershipTypes.push(self.profiles[membershipId].profile.membershipType);
							}
							self.profileSelected = self.profiles[membershipId].profile.membershipType;
						}
						drive.getFile(drive.files[`history${self.profileSelected}`]).then(function (fileDetails) {
							if (typeof fileDetails.data !== "undefined") {
								self.history = fileDetails.data.history;
							}
						})
					}
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Home.vue?ee553b42